module.exports = __webpack_public_path__ + "img/hammer-white.00b5bb1d.svg";